// Class: motion.easing.Back

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function motion_easing__$Back_BackEaseIn() {return require("./../../motion/easing/_Back/BackEaseIn");}
function motion_easing__$Back_BackEaseInOut() {return require("./../../motion/easing/_Back/BackEaseInOut");}
function motion_easing__$Back_BackEaseOut() {return require("./../../motion/easing/_Back/BackEaseOut");}

// Constructor

var Back = function(){}

// Meta

Back.__name__ = ["motion","easing","Back"];
Back.__isInterface__ = false;
Back.prototype = {
	
};
Back.prototype.__class__ = Back.prototype.constructor = $hxClasses["motion.easing.Back"] = Back;

// Init



// Statics

Back.easeInWith = function(s) {
	return new (motion_easing__$Back_BackEaseIn().default)(s);
}
Back.easeInOutWith = function(s) {
	return new (motion_easing__$Back_BackEaseInOut().default)(s);
}
Back.easeOutWith = function(s) {
	return new (motion_easing__$Back_BackEaseOut().default)(s);
}
Back.easeIn = new (motion_easing__$Back_BackEaseIn().default)(1.70158)
Back.easeInOut = new (motion_easing__$Back_BackEaseInOut().default)(1.70158)
Back.easeOut = new (motion_easing__$Back_BackEaseOut().default)(1.70158)

// Export

exports.default = Back;